import { render, staticRenderFns } from "./InputTextBase.vue?vue&type=template&id=2ea267a2&scoped=true&lang=pug&"
import script from "./InputTextBase.vue?vue&type=script&lang=ts&"
export * from "./InputTextBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea267a2",
  null
  
)

export default component.exports